import { render, staticRenderFns } from "./haoka3.vue?vue&type=template&id=778a91a7&scoped=true&"
import script from "./haoka3.vue?vue&type=script&lang=js&"
export * from "./haoka3.vue?vue&type=script&lang=js&"
import style0 from "./haoka3.vue?vue&type=style&index=0&id=778a91a7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778a91a7",
  null
  
)

export default component.exports